import StatusAvatar from "./StatusAvatar";

export default StatusAvatar;
